module.exports = __webpack_public_path__ + "img/fuki03_sp.9ecb43d8.png";